/**
 * Settings Routes
 */

import type { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "@/components/layout/protected-route";
import { EditProfilePage } from "./pages/edit-profile";
import { NotificationsPage } from "./pages/notifications";
import { SettingsPage } from "./pages/settings";

export const settingsRoutes: RouteObject[] = [
	{
		path: "/settings",
		element: (
			<ProtectedRoute requireUserType>
				<SettingsPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/profile/edit",
		element: (
			<ProtectedRoute requireUserType>
				<EditProfilePage />
			</ProtectedRoute>
		),
	},
	{
		path: "/notifications",
		element: (
			<ProtectedRoute requireUserType>
				<NotificationsPage />
			</ProtectedRoute>
		),
	},
];
